import { COLORS } from "../../common/constants";

const styles = {
  modalContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalStyle: {
    maxWidth: "80vw",
    bgcolor: COLORS.white,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "40vw",
    zIndex: 9998,
    padding: "16px",
    maxHeight: "90vh",
    position: "relative",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
    "& form": {
      minWidth: "55vw",
    },
  },
  closeButton: {
    position: "absolute",
    top: "20px",
    right: "20px",
    zIndex: 10001,
    color: COLORS.primary,
    border: `2px solid ${COLORS.primary}`,
    borderRadius: "8px",
    cursor: "pointer",
    height: "20px",
    width: "20px",
    backgroundColor: COLORS.white,
    "&:hover": {
      backgroundColor: COLORS.lightBlue,
    },
  },
};

export default styles;
